import { memo } from 'react';

interface PreviewSectionHeaderProps {
    title: string;
    titleColor: string;
    subtitle: string;
    subtitleColor: string;
    interactive?: boolean;
    onClick?: (id: string) => void;
}

export const PreviewSectionHeader = memo(({
    title,
    titleColor,
    subtitle,
    subtitleColor,
    interactive = true,
    onClick
}: PreviewSectionHeaderProps) => (
    <>
        <h2
            className="preview-section-title"
            style={{ color: titleColor }}
            onClick={interactive && onClick ? () => onClick('section-title-input') : undefined}
            title={interactive ? "Click to edit section title" : undefined}
        >
            {title || 'SECTION TITLE'}
        </h2>

        <p
            className="preview-section-subtitle"
            style={{ color: subtitleColor }}
            onClick={interactive && onClick ? () => onClick('section-subtitle-input') : undefined}
            title={interactive ? "Click to edit section subtitle" : undefined}
        >
            {subtitle || 'Section subtitle goes here.'}
        </p>
    </>
));
